__turbopack_context__.v({
  "button": "NavLink-module__8wH0IW__button",
  "text": "NavLink-module__8wH0IW__text",
});
